import React from "react"
import Helmet from "react-helmet"
import classNames from "classnames"

import { makeStyles } from "@material-ui/core/styles"
import Layout from "src/components/Layout"

import GlobalBaseState from "src/assets/js/GlobalBaseState.js"

// Sections for this page
import FilteredProperties from "./Sections/FilteredProperties"

import styles from "src/assets/jss/material-kit-react/views/ListingsView"
const useStyles = makeStyles(styles)

export default function ListingsView({ pageContent, ...rest }) {
  const pageClasses = useStyles()

  const [globalState, setGlobalState] = React.useState(GlobalBaseState)

  return (
    <Layout
      pageClasses={pageClasses}
      scaffolding={pageContent.scaffolding}
      globalState={globalState}
      {...rest}
    >
      {(
        isLandscape /** isLandscape passed as method parameter through layout component */
      ) => (
        <>
          <Helmet>
            <body
              className={classNames(pageClasses.body, "listings-page-wrapper")}
            />
          </Helmet>
          <FilteredProperties
            pageContent={pageContent}
            globalState={globalState}
            isLandscape={isLandscape}
            {...rest}
          />
        </>
      )}
    </Layout>
  )
}
